import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";
import {
  IFunderInvestmentListItem,
  IPaginated,
} from "../interfaces/funderInvestment";

type TQuery = {
  id: number;
  currency: string;
  investmentProductId: number;
  page?: number;
  pageSize?: number;
};

export const EACH_INVESTORS_INVESTMENT_KEY = "getEachInvestorsInvestment";

/**
 * An investor's investments in one product and currency, a page at a time.
 *
 * The rows are summaries: totals deposited and withdrawn, no interest or
 * wallet fields. Anything that acts on one investment fetches it by id.
 */
const getEachInvestorsInvestment = async ({
  id,
  currency,
  investmentProductId,
  page = 1,
  pageSize = 20,
}: TQuery): Promise<IPaginated<IFunderInvestmentListItem> | undefined> => {
  if (investmentProductId && currency && id) {
    const queryParams = `?FunderId=${Number(id)}&InvestmentProductId=${Number(
      investmentProductId,
    )}&Currency=${currency}&Page=${page}&PageSize=${pageSize}`;

    const data = await getData(
      `${ajaxEndpoints.INVESTORS_INVESTMENT}${queryParams}`,
    );
    return data.data;
  }
};

export default function useEachInvestorsInvestment({
  id,
  currency,
  investmentProductId,
  page = 1,
  pageSize = 20,
}: TQuery) {
  return useQuery(
    [
      { id, currency, investmentProductId, page, pageSize },
      EACH_INVESTORS_INVESTMENT_KEY,
    ],
    getEachInvestorsInvestment,
    {
      refetchOnWindowFocus: false,
    },
  );
}
